// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    width={144}
    height={144}
    viewBox="0 0 144 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Property 1=Watch, Property 2=Blue, Property 3=144px">
      <g id="Watch">
        <path
          id="Vector"
          d="M94.4935 115.422H49.2168V136.152H94.4935V115.422Z"
          fill="#ABE3FF"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_2"
          d="M94.4935 7.56055H49.2168V31.7393H94.4935V7.56055Z"
          fill="#ABE3FF"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_3"
          d="M124.981 71.7636C124.981 64.8113 123.611 57.9271 120.95 51.5042C118.288 45.0813 114.388 39.2454 109.47 34.3299C104.553 29.4143 98.7153 25.5154 92.2907 22.8558C85.866 20.1961 78.9803 18.8279 72.0267 18.8291C57.9849 18.8291 44.5182 24.4061 34.5892 34.3332C24.6602 44.2604 19.082 57.7245 19.082 71.7636C19.082 85.8026 24.6602 99.2667 34.5892 109.194C44.5182 119.121 57.9849 124.698 72.0267 124.698C78.9803 124.699 85.866 123.331 92.2907 120.671C98.7153 118.012 104.553 114.113 109.47 109.197C114.388 104.282 118.288 98.4458 120.95 92.0229C123.611 85.6 124.981 78.7158 124.981 71.7636Z"
          fill="#0078EF"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_4"
          d="M115.702 71.7624C115.702 60.1823 111.101 49.0765 102.911 40.8882C94.7208 32.6998 83.6129 28.0996 72.0305 28.0996C60.4482 28.0996 49.3403 32.6998 41.1503 40.8882C32.9604 49.0765 28.3594 60.1823 28.3594 71.7624C28.3594 77.4963 29.4889 83.174 31.6836 88.4715C33.8783 93.7689 37.0951 98.5822 41.1503 102.637C49.3403 110.825 60.4482 115.425 72.0305 115.425C83.6126 115.424 94.7201 110.824 102.91 102.636C111.1 94.4476 115.701 83.3423 115.702 71.7624Z"
          fill="#FCFBF7"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_5"
          d="M72.0236 42.8008V71.7631L50.25 93.4245C55.7123 98.6823 62.998 101.622 70.5803 101.628C78.4016 101.627 85.9024 98.5203 91.4326 92.9906C96.9629 87.4608 100.07 79.9612 100.07 72.1414C100.07 56.3506 87.6266 43.57 72.0236 42.8008Z"
          fill="#29A9FF"
        />
        <path
          id="Vector_6"
          d="M72.0236 42.8008V71.7631L50.25 93.4245"
          stroke="#29292F"
          strokeWidth={1.5}
        />
        <path
          id="Vector_7"
          d="M72.0273 28.0996V35.3766"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_8"
          d="M115.694 71.7627H108.414"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_9"
          d="M115.694 71.7627H108.414"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_10"
          d="M72.0273 115.427V108.146"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_11"
          d="M28.3594 71.7627H35.6395"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_12"
          d="M102.905 40.8867L97.7617 46.0337"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_13"
          d="M41.1445 102.636L46.2883 97.4893"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_14"
          d="M41.1445 40.8867L46.2883 46.0337"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
        <path
          id="Vector_15"
          d="M102.905 102.636L97.7617 97.4893"
          stroke="#29292F"
          strokeWidth={1.5}
          strokeMiterlimit={10}
        />
      </g>
    </g>
  </svg>
);
const SvgWatch = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgWatch;
